/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// de
t.add("cart.tickets.no_available_tickets_for_seating", "F\u00fcr die ausgew\u00e4hlten Sitzpl\u00e4tze sind keine Tickets erh\u00e4ltlich.", "PayseraCartBundle", "de");
t.add("cart.tickets.no_available_tickets", "Es sind keine Tickets erh\u00e4ltlich", "PayseraCartBundle", "de");
t.add("paysera_cart.discount.invalid_code", "Ung\u00fcltiger Rabattcode", "PayseraCartBundle", "de");
})(Translator);
